import {
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
} from '@chakra-ui/react';

import { CloseCircleOutline } from '@aslanpay/portal-common-lib';

import AddPersonForm from './AddPersonForm';

export interface AddPersonModalProps {
  isOpen: boolean;
  onClose: () => void;
  companyId: string;
  onSuccess: () => void;
}

function AddPersonModal({ isOpen, onClose, companyId, onSuccess }: AddPersonModalProps) {
  const handleSuccess = () => {
    onClose();
    onSuccess();
  };

  return (
    <Modal
      isOpen={isOpen}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      onClose={onClose}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <Text as="h6">Add a person</Text>
            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close add person"
              onClick={onClose}
            />
          </HStack>
        </ModalHeader>
        <ModalBody pb="40px">
          <AddPersonForm companyId={companyId} onSuccess={handleSuccess} onCancel={onClose} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default AddPersonModal;
